import { useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const GenderContext = createContext(null);

type Props = {
  children: ReactElement;
};

const GenderProvider: FunctionComponent<Props> = ({ children }) => {
  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["gender"],
    staleTime: 30000,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`overview?keyword=gender`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      isFetching,
      error,
    }),
    [isLoading, data, error, isFetching],
  );
  return (
    <GenderContext.Provider value={contextValue}>
      {children}
    </GenderContext.Provider>
  );
};

export default GenderProvider;
